@use '../../../../assets/styles/utilities.scss';
$color-gray-200: #e5e7eb;
$color-gray-300: #d2d5db;
$color-gray-700: #374151;
$color-gray-900: #111827;
$color-blue-600: #2563eb;
$color-red-600: #dc2626;

:host {
  display: block;
}

.otp-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: $color-gray-700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.otp-wrapper {
  display: flex;
  position: relative;
  justify-content: center;
  gap: 2rem;
  background: #fff;
  border: 1px solid $color-gray-300;
  border-radius: 0.75rem;
  margin: 0 auto;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;

  &.focused {
    border-color: $color-blue-600;
    box-shadow: 0 0 0 3px rgba($color-blue-600, 0.15);
  }

  &.error {
    border-color: $color-red-600;
    box-shadow: 0 0 0 3px rgba($color-red-600, 0.1);
  }
}

.otp-dots {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 16px 40px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: $color-gray-200;
  border: none;
  font-size: 20px;
  text-align: center;
  caret-color: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  transition: background-color 0.2s ease, transform 0.2s ease;

  &.filled {
    background-color: $color-gray-900;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba($color-blue-600, 0.3);
  }
}

.error-text {
  color: $color-red-600;
  font-size: 0.75rem;
  margin-top: 0.5rem;
  text-align: center;
}

.otp-sms-autofill {
  position: absolute;
  z-index: -1;
  outline: 0 !important;
  width: 100%;
  height: 100%;
  pointer-events: none;
  caret-color: transparent;
}
